import * as React from 'react';
import { Responsive, UIHeading2, UIHeading4 } from '@cian/ui-kit';
import * as styles from './ProjectInfo.css';

export interface IProjectInfoProps {
  name: string;
  parameters?: string;
  constructionTime?: string;
  description?: string;
  price?: string;
  labels: React.ReactNode;
}

export const ProjectInfo: React.FC<IProjectInfoProps> = ({
  name,
  parameters,
  constructionTime,
  description,
  price,
  labels,
}) => {
  return (
    <div className={styles['container']}>
      <div className={styles['name']}>{name}</div>

      {parameters && (
        <div className={styles['parameters']}>
          <UIHeading4>{parameters}</UIHeading4>
        </div>
      )}

      {constructionTime && <div className={styles['construction-time']}>Срок строительства: {constructionTime}</div>}

      <Responsive desktop>
        <div className={styles['labels']}>{labels}</div>
      </Responsive>

      {price && (
        <div className={styles['price']}>
          <UIHeading2>{price}</UIHeading2>
        </div>
      )}

      <Responsive desktop>
        <div className={styles['description']}>{description}</div>
      </Responsive>
    </div>
  );
};
